import apiClient from '@/Services/Clients/apiClient';
import ConfigurableFieldsModel from '@/Models/configurableFieldsModel';
import { UploadParentItemType } from '@/Types/Enums/UploadParentItemType';

const CONFIGURABLE_FIELD_BASE_URL = 'api/configurablefield';

export default class ConfigurableFieldService {

  public static getUploadParentConfigurableFields(parentId: string, parentItemType: UploadParentItemType): Promise<ConfigurableFieldsModel> {
    const uri = `${CONFIGURABLE_FIELD_BASE_URL}/${parentItemType === UploadParentItemType.selfResponse ? 'selfresponse' : 'request'}/${parentId}`;
    return apiClient.get(uri);
  }
}